import React, { useCallback, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import "./style.scss";
import { getPublicHelpCenterGetEbSidebarDetail } from "@zkt/open-api/esm/feedback";
import { config } from "@zkt/eb-utility";
import { ChevronRight } from "@zkt/icons";

export default function HelpSidebar(): JSX.Element {
  const { pathname } = useLocation();
  const [dynamicTop, setDynamicTop] = useState(69);
  const [show, setShow] = useState(false);
  const [visible, setVisible] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const [url, setUrl] = useState("");
  const [height, setHeight] = useState("auto");

  function setHeightFn() {
    setHeight(`${window.innerHeight - 69}px`);
  }

  const getPublicHelp = useCallback(() => {
    getPublicHelpCenterGetEbSidebarDetail({
      url: pathname,
    })
      .then((data) => {
        const { openStatus, helpCenterSidebarId } = data;
        setShow(!!openStatus);
        setVisible(helpCenterSidebarId != null);
        setHeightFn();
        const callbackUrl = encodeURIComponent(pathname);
        setUrl(
          `//${config.helpHOST}/#/sidebar?source=EB_SIDEBAR&url=${callbackUrl}`
        );
      })
      .catch(() => {
        setShow(false);
      });
  }, [pathname]);

  function handleClick() {
    const newSHow = !show;
    setShow(newSHow);
  }

  function iframeLoad() {
    setLoaded(true);
  }
  const scrollEvt = useCallback(() => {
    if (!show) return;
    const { scrollTop } = document.documentElement;
    if (scrollTop < 69 && scrollTop > 0) {
      setDynamicTop(69 - scrollTop);
    }
    if (scrollTop === 0) {
      setDynamicTop(69);
    }
    if (scrollTop > 69) {
      setDynamicTop(0);
    }
  }, [show]);

  useEffect(() => {
    setLoaded(false);
    setShow(false);
    setVisible(false);
    if (!pathname.includes("#") && pathname !== "/") {
      getPublicHelp();
    }
  }, [pathname, getPublicHelp]);
  useEffect(() => {
    window.addEventListener("scroll", scrollEvt);
    return () => {
      window.removeEventListener("scroll", scrollEvt);
    };
  }, [show, scrollEvt]);
  return (
    visible && (
      <div
        style={{ transform: `translateY(${dynamicTop}px)` }}
        className={`help-sidebar ${show ? "is-show" : ""}`}
      >
        <button type="button" className="btn btn-primary" onClick={handleClick}>
          <ChevronRight className={`${show ? "rightArrow" : "leftArrow"}`} />
          {show ? "收回" : "帮助"}
        </button>
        <div className="iframe-wrapper">
          {loaded && !url && <div>地址错误</div>}
          {show && (
            <iframe
              title="帮助中心"
              style={{
                visibility: loaded ? "visible" : "hidden",
                height: `${height}`,
              }}
              src={url}
              className="iframe-content"
              onLoad={iframeLoad}
            />
          )}
          {!loaded && (
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                height: "400px",
                background:
                  " url(data:image/svg+xml;base64,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) center no-repeat",
              }}
            />
          )}
        </div>
      </div>
    )
  );
}
